const Tactic = require('../strategy/tactic');
const CardTactic = require('./card-tactic');
const Expandable = require('../ui/expandable');
const Renameable = require('../../lib/util/behaviors/renameable');
const ListItemMenu = require('../ui/list-item-menu');
const MenuItem = require('../ui/list-menu-item');
const events = require('../ui/events');
const CardDetailService = require('../../services').Cards;
const CardScore = require('../analysis/metrics/card-score');
const template = require('./card.tpl').default;

module.exports = DomClass(template, function Card() {
	var _t = this;

	let detailsCacheKey = null;
	let detailsCache = null;

	var renamed = false;

	Expandable.call(this, this.expandHeader);
	var onstartrename = Renameable.call(this);

	const onchange = on(this, 'change');
	const onrename = on(this, 'rename');
	const ontogglecommander = on(this, 'togglecommander');


	// would rather duck-type this a bit more; but these fields are used
	// in enough places that we need some defaults on them ...
	this.name = typeof this.name === 'string' ? this.name : '';
	this.type = this.type || 'unknown';
	// this.legalities = this.legalities || {};
	this.text = this.text || '';
	this.image = this.image || '';
	this.isCommander = this.isCommander || false;

	this.activeQuantity = 0;
	this.quantity = Number.isNaN(Number.parseInt(this.quantity)) ?
		1 : Number.parseInt(this.quantity);
	this.sideboarded = Number.isNaN(Number.parseInt(this.sideboarded)) ?
		0 : Number.parseInt(this.sideboarded);

	// .image will exist from before this update.
	// .rarity will not...
	this.refresh = async function() {
		_t.sideboardedView = Number(_t.sideboarded);
		if (_t.sideboardedView > 0) {
			_t.modifiers.style.display = '';
		} else {
			_t.modifiers.style.display = 'none';
		}
		if (this.isCommander) {
			this.lockQuantities();
			this.classList.add('commander');
			this.activeQuantity = 1;
		} else {
			this.classList.remove('commander');
			this.activeQuantity = this.quantity - this.sideboarded;
		}
		await this.showImage();
		this.setCommanderControls();
	};

	this.canBeCommander = () => {
		const type = this.type?.trim().toLowerCase() || '';

		// commanders must be legendary
		return type.startsWith("legendary")
			&& (
				// and must be creatures
				type.includes('creature')

				// or planeswalkers that explicitly say something like
				// "<name> can be your commander"
				|| this.text.toLowerCase().includes(
					this.name.toLowerCase() + ' can be your commander'
				)
			);
	};

	this.setCommanderControls = () => {
		if (this.canBeCommander()) {
			if (this.isCommander) {
				this.toggleCommanderText = "Demote from Commander";
			} else {
				this.toggleCommanderText = "Promote to Commander";
			}
			this.commanderControls.style.display = '';
		} else {
			this.commanderControls.style.display = 'none';
		}
	};

	this.toJSON = () => ({
		name: this.name,
		quantity: this.quantity,
		sideboarded: this.sideboarded,
		tactics: this.tactics
	});

	this.getDetails = async () => {
		if (this.name && detailsCacheKey !== this.name) {
			this.detailsCache = CardDetailService.get(this.name);
		}
		return this.detailsCache;
	};

	this.showImage = async function() {
		if (renamed || !this.image) {
			_t.image = '';
			_t.preview = '';
			return _t.getDetails().then(function(card) {
				if (card) {
					const prices = card.prices || {};
					_t.name = card.name;
					_t.text = card.text;
					_t.type = card.type;
					_t.cmc = card.cmc;
					_t.manaCost = card.manaCost;
					_t.power = card.power;
					_t.toughness = card.toughness;
					_t.rarity = card.rarity;
					_t.image = 'https://gatherer.wizards.com/Handlers/Image.ashx?multiverseid='
						+ card.multiverseid + '&type=card';
					_t.preview = _t.image;
					_t.legalities = card.legalities;
					_t.lowPrice = prices.low || '?';
					_t.avgPrice = prices.average || '?';
					_t.highPrice = prices.high || '?';
					_t.score = (new CardScore([{...card, quantity: 1}]).average).toFixed(2);
					onchange.fire(_t);
				}
			});
			renamed = false;
		} else {
			_t.preview = _t.image;	// actually fetch the preview image.
		}
	};

	this.lockQuantities = () => {
		this.classList.add('locked');
		this.__dom.activeQuantity.readOnly = true;
		this.__dom.sideboarded.readOnly = true;
		this.__dom.sideboardInc.style.display = 'none';
		this.__dom.sideboardDec.style.display = 'none';

		// hack. these are getting locked when "promote to commander" is clicked.
		// no idea why yet.
		this.tacticOptions.forEach(function(tactic) { tactic.unlock(); });
	};

	this.unlockQuantities = () => {
		this.classList.remove('locked');
		this.__dom.activeQuantity.readOnly = false;
		this.__dom.sideboarded.readOnly = false;
		this.__dom.sideboardInc.style.display = '';
		this.__dom.sideboardDec.style.display = '';
	};

	this.lock = function() {
		this.lockQuantities();
		this.tacticOptions.forEach(function(tactic) { tactic.lock(); });
	};

	this.unlock = function() {
		this.unlockQuantities();
		this.tacticOptions.forEach(function(tactic) { tactic.unlock(); });
	};

	this.quantity = Number(this.quantity);

	this.activeQuantity = Number(this.quantity) - Number(this.sideboarded);
	this.__dom.activeQuantity.onchange = () => {
		this.quantity = Number(this.activeQuantity) + Number(this.sideboarded)
		onchange.fire(_t);
	};

	this.__dom.sideboarded.onchange = () => {
		this.quantity = Number(this.activeQuantity) + Number(this.sideboarded)
		onchange.fire(_t);
		_t.refresh();
	};

	this.sideboardInc.onclick = () => {
		this.sideboarded = Math.min(
			this.quantity, Number(this.sideboarded) + 1
		);
		onchange.fire(this);
	};

	this.sideboardDec.onclick = () => {
		this.sideboarded = Math.max(
			0, Number(this.sideboarded) - 1
		);
		onchange.fire(this);
	};

	this.toggleCommander.onclick = () => {
		ontogglecommander.fire(this);
	};

	this.promoteToCommander = () => {
		this.isCommander = true;
		this.refresh();
	};

	this.demoteFromCommander = () => {
		this.isCommander = false;
		this.refresh();
	};

	this.remove = function() {
		on(this, 'remove').fire(this);
	};

	onrename.then(function() {
		renamed = true;
		_t.refresh();
	});

	this.setTacticOptions = function(tactics) {
		var tactics = tactics || [];
		if (!this.hasTacticOptions(tactics)) {
			var selections = generateTacticSelections(tactics);
			this.setSelections(selections);
		}
	};

	var generateTacticSelections = function(tactics) {
		return tactics.map(getTacticOption);
	};

	var tacticOptionsCache = {};
	var getTacticOption = function(tactic) {
		if (tacticOptionsCache[tactic.name]) {
			return tacticOptionsCache[tactic.name];
		}

		var ct = buildCardTactic(tactic);
		tacticOptionsCache[tactic.name] = ct;

		if (_t.classList.contains('locked')) {
			ct.lock();
		}

		return ct;
	};

	var buildCardTactic = function(tactic) {
		var ct = new CardTactic({
			name: tactic.name,
			selected: _t.tactics[tactic.name]
		});

		on(ct, 'change', function() {
			_t.tactics[ct.name] = ct.selected;
			onchange.fire(_t);
		});

		on(tactic, 'rename', function() {
			_t.tactics[tactic.name] = ct.selected;
			delete _t.tactics[ct.name];
			ct.name = tactic.name;
			onchange.fire(_t);
		});

		return ct;
	};

	this.setSelections = function(selections) {
		var tacticSelections = {};
		selections.forEach(function(t) {
			if (t.selected) tacticSelections[t.name] = true;
		});
		this.tactics = tacticSelections;
		this.tacticOptions = selections;
	};

	this.hasTacticOptions = function(tacticOptions) {
		if (tacticOptions.length != this.tacticOptions.length) {
			return false;
		}

		for (var i = 0; i < tacticOptions.length; i++) {
			var existing = this.tacticOptions[i];
			if (!existing || tacticOptions[i].name != existing.name) {
				return false;
			}
		}

		return true;
	};

	if (!this.tactics || typeof(this.tactics) != 'object' || isa(this.tactics, Array)) {
		this.tactics = {};
	}
	this.tacticOptions = [];

	this.menu.items = [
		new MenuItem({name: 'Rename', target: function() { onstartrename.fire(); } }),
		new MenuItem({name: 'REMOVE', target: function() { _t.remove(); }})
	];

});
